import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';
import { COUNTRY_CODE_NL, COUNTRY_CODE_ES, COUNTRY_CODE_PT, COUNTRY_CODE_DE } from 'commonsConstants/countryCodes';
import { DOCUMENT_TYPES } from 'constants/documents';
import {
    OWN_ACCOUNT,
    SALARIED,
    RENTIER,
    PENSIONER,
    NO_ACTIVITY,
    UNEMPLOYED,
    HOMEWORK,
    STUDENT,
} from 'constants/userProfile';
import cueFront from 'assets/images/documentation/cue-front.png';
import passportFront from 'assets/images/documentation/passport-front.png';
import passportBack from 'assets/images/documentation/passport-back.png';
import tieFront from 'assets/images/documentation/tie-front.png';
import tieBack from 'assets/images/documentation/tie-back.png';
import dniFrontSpain from 'assets/images/documentation/dni-front-spain.png';
import dniFrontPortugal from 'assets/images/documentation/dni-front-portugal.png';
import dniFrontNetherlands from 'assets/images/documentation/dni-front-netherlands.png';
import dniFrontGermany from 'assets/images/documentation/dni-front-germany.png';
import dniBackSpain from 'assets/images/documentation/dni-back-spain.png';
import dniBackPortugal from 'assets/images/documentation/dni-back-portugal.png';
import dniBackNetherlands from 'assets/images/documentation/dni-back-netherlands.png';
import dniBackGermany from 'assets/images/documentation/dni-back-germany.png';

const currentCountry = getReferenceCodeByCountry().toUpperCase();

const IdCardByCountryMap = {
    [DOCUMENT_TYPES.DNI_FRONT]: {
        [COUNTRY_CODE_ES]: dniFrontSpain,
        [COUNTRY_CODE_PT]: dniFrontPortugal,
        [COUNTRY_CODE_NL]: dniFrontNetherlands,
        [COUNTRY_CODE_DE]: dniFrontGermany,
    },
    [DOCUMENT_TYPES.DNI_BACK]: {
        [COUNTRY_CODE_ES]: dniBackSpain,
        [COUNTRY_CODE_PT]: dniBackPortugal,
        [COUNTRY_CODE_NL]: dniBackNetherlands,
        [COUNTRY_CODE_DE]: dniBackGermany,
    },
};

export const imageContentMap = {
    [DOCUMENT_TYPES.DNI_FRONT]: {
        image: IdCardByCountryMap[DOCUMENT_TYPES.DNI_FRONT][currentCountry],
        title: 'uploads-dniFrontTitle',
        subtitle: 'uploads-dniSubtitle',
    },
    [DOCUMENT_TYPES.DNI_BACK]: {
        image: IdCardByCountryMap[DOCUMENT_TYPES.DNI_BACK][currentCountry],
        title: 'uploads-dniBackTitle',
        subtitle: 'uploads-dniSubtitle',
    },
    [DOCUMENT_TYPES.NIE_FRONT]: {
        image: cueFront,
        title: 'uploads-cueTitle',
        subtitle: 'uploads-dniSubtitle',
    },
    [DOCUMENT_TYPES.PASSPORT_FRONT]: {
        image: passportFront,
        title: 'uploads-passportTitle',
        subtitle: 'uploads-dniSubtitle',
    },
    [DOCUMENT_TYPES.PASSPORT_BACK]: {
        image: passportBack,
        title: 'uploads-passportBackTitle',
        subtitle: 'uploads-dniSubtitle',
    },
    [DOCUMENT_TYPES.PERMIT_FRONT]: {
        image: tieFront,
        title: 'uploads-tieFrontTitle',
        subtitle: 'uploads-dniSubtitle',
    },
    [DOCUMENT_TYPES.PERMIT_BACK]: {
        image: tieBack,
        title: 'uploads-tieBackTitle',
        subtitle: 'uploads-dniSubtitle',
    },
};

export const documentsAcceptedContentMap = {
    [DOCUMENT_TYPES.DAAL]: {
        [OWN_ACCOUNT]: {
            conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
            documents: [
                { document: 'uploads-companyCertDocument', time: 'uploads-last6months' },
                { document: 'uploads-IRPFDeclarationDocument', time: 'uploads-lastYear' },
                { document: 'uploads-SSDocument', time: 'uploads-lastYear' },
            ],
        },
        [SALARIED]: {
            conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
            documents: [
                { document: 'uploads-payrollDocument', time: 'uploads-last6months' },
                { document: 'uploads-workingLifeCertDocument', time: 'uploads-last6months' },
                { document: 'uploads-companyCertDocument', time: 'uploads-last6months' },
                { document: 'uploads-IRPFDeclarationDocument', time: 'uploads-lastYear' },
                { document: 'uploads-BOEDocument', time: 'uploads-lastYear' },
            ],
        },
        [RENTIER]: {
            conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
            documents: [
                { document: 'uploads-IRPFDeclarationDocument', time: 'uploads-lastYear' },
                { document: 'uploads-wealthTax', time: 'uploads-last6months' },
            ],
        },
        [PENSIONER]: {
            conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
            documents: [
                { document: 'uploads-pensionDocument', time: 'uploads-last6months' },
                { document: 'uploads-pensionCert', time: 'uploads-issueDate' },
                { document: 'uploads-IRPFDeclarationDocument', time: 'uploads-lastYear' },
                { document: 'uploads-lastReassessmentCert', time: 'uploads-lastYear' },
                { document: 'uploads-bankDocument', time: 'uploads-last6months' },
            ],
        },
        [NO_ACTIVITY]: {
            [HOMEWORK]: {
                [COUNTRY_CODE_ES]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        {
                            document: 'documentationHomework-laboralLife',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        {
                            document: 'documentationHomework-inheritanceOrDonation',
                            time: 'documentationValidity-lastYear',
                        },
                        { document: 'documentationHomework-investments', time: 'documentationValidity-lastYear' },
                        {
                            document: 'documentationHomework-fundsDocumentationProof',
                            time: 'documentationValidity-lastYear',
                        },
                        {
                            document: 'documentationHomework-bankJointholderCertificate',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        {
                            document: 'documentationHomework-sepePayment',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        { document: 'documentationHomework-ifprStatement', time: 'documentationValidity-lastYear' },
                    ],
                },
                [COUNTRY_CODE_DE]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        {
                            document: 'documentationHomework-inheritanceOrDonation',
                            time: 'documentationValidity-lastYear',
                        },
                        { document: 'documentationHomework-investments', time: 'documentationValidity-lastYear' },
                        {
                            document: 'documentationHomework-bankStatement',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        {
                            document: 'documentationHomework-bankJointholderCertificate',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                    ],
                },
                [COUNTRY_CODE_NL]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        {
                            document: 'documentationHomework-ifprStatement',
                            time: 'documentationValidity-lastPresentation',
                        },
                        {
                            document: 'documentationHomework-inheritanceOrDonation',
                            time: 'documentationValidity-lastYear',
                        },
                        { document: 'documentationHomework-investments', time: 'documentationValidity-lastYear' },
                        {
                            document: 'documentationHomework-fundsDocumentationProof',
                            time: 'documentationValidity-lastYear',
                        },
                    ],
                },
                [COUNTRY_CODE_PT]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        { document: 'documentationHomework-inheritanceOrDonation' },
                        { document: 'documentationHomework-investments', time: 'documentationValidity-lastYear' },
                        {
                            document: 'documentationHomework-bankStatement',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        {
                            document: 'documentationHomework-bankJointholderCertificate',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        { document: 'documentationHomework-ifprStatement', time: 'documentationValidity-lastYear' },
                    ],
                },
            },
            [UNEMPLOYED]: {
                [COUNTRY_CODE_ES]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        {
                            document: 'documentationUnemployed-laboralLife',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        {
                            document: 'documentationUnemployed-unemployedPaymentProof',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        {
                            document: 'documentationUnemployed-inheritanceOrDonation',
                            time: 'documentationValidity-lastYear',
                        },
                        {
                            document: 'documentationUnemployed-investments',
                            time: 'documentationValidity-lastYear',
                        },
                    ],
                },
                [COUNTRY_CODE_DE]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        {
                            document: 'documentationUnemployed-laboralLife',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        {
                            document: 'documentationUnemployed-unemployedPaymentProof',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                    ],
                },
                [COUNTRY_CODE_NL]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        {
                            document: 'documentationUnemployed-laboralLife',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        {
                            document: 'documentationUnemployed-irsModel',
                            time: 'documentationValidity-lastPresentation',
                        },
                        {
                            document: 'documentationUnemployed-unemployedPaymentProof',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                    ],
                },
                [COUNTRY_CODE_PT]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        {
                            document: 'documentationUnemployed-laboralLife',
                            time: 'documentationValidity-lastThreeMonths',
                        },
                        { document: 'documentationUnemployed-irsModel', time: 'documentationValidity-lastYear' },
                        {
                            document: 'documentationUnemployed-unemployedPaymentProof',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        {
                            document: 'documentationUnemployed-bankExtractWithMovements',
                            time: 'documentationValidity-lastThreeMonths',
                        },
                    ],
                },
            },
            [STUDENT]: {
                [COUNTRY_CODE_ES]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        { document: 'documentationStudent-studiesEnrollment', time: 'documentationValidity-lastYear' },
                        {
                            document: 'documentationStudent-scholarshipProof',
                            time: 'documentationValidity-lastYear',
                        },
                        { document: 'documentationStudent-UniversityCard' },
                    ],
                },
                [COUNTRY_CODE_DE]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        { document: 'documentationStudent-studiesEnrollment', time: 'documentationValidity-lastYear' },
                    ],
                },
                [COUNTRY_CODE_NL]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        { document: 'documentationStudent-studiesEnrollment', time: 'documentationValidity-lastYear' },
                        { document: 'documentationStudent-scholarshipProof', time: 'documentationValidity-lastYear' },
                        {
                            document: 'documentationStudent-lastTaxDeclaration',
                            time: 'documentationValidity-lastPresentation',
                        },
                    ],
                },
                [COUNTRY_CODE_PT]: {
                    conditions: ['uploads-indicatedTimePeriod', 'uploads-crossedOutData'],
                    documents: [
                        { document: 'documentationStudent-studiesEnrollment', time: 'documentationValidity-lastYear' },
                        {
                            document: 'documentationStudent-scholarshipProof',
                            time: 'documentationValidity-noMoreThanSixMonths',
                        },
                        { document: 'documentationStudent-UniversityCard' },
                    ],
                },
            },
        },
    },
    [DOCUMENT_TYPES.RECIBO_TRANSFERENCIA]: {
        conditions: ['uploads-indicatedTimePeriod', 'uploads-personalData'],
        documents: [
            { document: 'uploads-municipalRegister', time: 'uploads-last6months' },
            { document: 'uploads-bill', time: 'uploads-last6months' },
        ],
    },
};
